import React from 'react';
import PickMuse from '../domains/muses/components/PickMuse';
import { MyMusesProps } from '../types';

const PickMusePage: React.FC<MyMusesProps> = ({ onMuseSelect }) => {
  return <PickMuse onMuseSelect={onMuseSelect} />;
};

export default PickMusePage; 